(() => {
  const desktopQuery = window.matchMedia('(min-width: 1100px)');
  const OPEN_DELAY = 140;
  const CLOSE_DELAY = 220;
  let activeItem = null;

  const getTrigger = (item) => item.querySelector(':scope > .header__menu-item');

  const setExpanded = (item, expanded) => {
    const trigger = getTrigger(item);
    if (trigger) trigger.setAttribute('aria-expanded', String(expanded));
  };

  const closeItem = (item, returnFocus = false) => {
    if (!item) return;
    window.clearTimeout(item._premiumOpenTimer);
    window.clearTimeout(item._premiumCloseTimer);
    item.classList.remove('is-open');
    setExpanded(item, false);
    if (activeItem === item) activeItem = null;
    if (returnFocus) getTrigger(item)?.focus();
  };

  const closeAll = (except = null) => {
    document.querySelectorAll('[data-premium-submenu-item].is-open').forEach((item) => {
      if (item !== except) closeItem(item);
    });
  };

  const openItem = (item) => {
    if (!desktopQuery.matches) return;
    window.clearTimeout(item._premiumCloseTimer);
    closeAll(item);
    item.classList.add('is-open');
    setExpanded(item, true);
    activeItem = item;
  };

  const bindItem = (item) => {
    if (item.dataset.premiumSubmenuBound === 'true') return;
    item.dataset.premiumSubmenuBound = 'true';

    item.addEventListener('mouseenter', () => {
      if (!desktopQuery.matches) return;
      window.clearTimeout(item._premiumCloseTimer);
      item._premiumOpenTimer = window.setTimeout(() => openItem(item), OPEN_DELAY);
    });

    item.addEventListener('mouseleave', () => {
      if (!desktopQuery.matches) return;
      window.clearTimeout(item._premiumOpenTimer);
      item._premiumCloseTimer = window.setTimeout(() => closeItem(item), CLOSE_DELAY);
    });

    item.addEventListener('focusin', () => openItem(item));
    item.addEventListener('focusout', (event) => {
      if (item.contains(event.relatedTarget)) return;
      item._premiumCloseTimer = window.setTimeout(() => closeItem(item), 0);
    });

    item.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      closeItem(item, true);
    });
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-premium-submenu-item]').forEach(bindItem);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('pointerdown', (event) => {
    if (activeItem && !activeItem.contains(event.target)) closeAll();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeItem) closeItem(activeItem, true);
  });
  desktopQuery.addEventListener('change', () => closeAll());
})();
